import style from "./style.module.scss";

export default function ListSlct(props) {
  const { values, allLabel } = props;

  const _values = values?.length > 0 ? values : [{ label: allLabel }];
  return (
    <span className={style.select}>
      {_values?.map(__value => (
        <span className={style.option}>{__value.label || "?"}</span>
      ))}
    </span>
  );
}
